function gatewayIsPendingReset(gateway) {
  return gateway.data.resetRequestMetadata?.state === 'sent' || gateway.data.resetRequestMetadata?.state === 'pending';
}
export default {
  gatewayIsPendingReset
};